import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { translate } from 'services/i18nService';
import AwardPrizeIcon from 'components/AwardPrizeIcon/AwardPrizeIcon';

import styles from './Award.css';


const Award = (props) => {
  const { award, allAwards } = props;

  return (
    <div className={allAwards ? styles.awardSeeAllActiveState : styles.awardWrapperDefaultState}>
      <AwardPrizeIcon rank={award.rank} type={award.awardType} />
      <div className={allAwards ? styles.allAwardsInfo : styles.info}>
        <span className={styles.date}>{moment(award.date).format('MMMM YYYY')}</span>
        <span>{translate(`v2profile.cam.of.the.${award.awardType}`)}</span>
      </div>
    </div>
  );
};

Award.propTypes = {
  allAwards: PropTypes.bool,
  award: PropTypes.object,
};

Award.defaultProps = {
  allAwards: false,
  award: {},
};

export default Award;
